<template>
    <v-card tile flat :class="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="live-trade-details-card">
        <v-row dense class="mt-4">
            <v-col cols="12" sm="12" md="6" lg="8">
                <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify"
                    label="Search anything here ..." single-line solo hide-details class="mt-0"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2">
                <v-select solo :items="generateLevelsArray" v-model="selectedLevel" append-icon="mdi-chevron-down"
                    label="All Level" class="custom-select mr-0 mt-0" @change="levelFilter"></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2">
                <div class="d-flex flex-column align-center justify-end">
                    <span class="text--ash">Total Commissions:</span>
                    <span>{{ totalCommissionSum.toFixed(2) || 0.00 }} $</span>
                </div>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="12">
                <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                    <v-sheet class="transactionTable depositTabTable"
                        :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
                        <v-data-table :headers="headers" :items="clientsummary"
                            :server-items-length="pagination?.total || 5" :options.sync="options" :loading="isLoading"
                            :items-per-page="options.itemsPerPage" :footer-props="{
                                'items-per-page-options': [5, 10, 25, 50, 100],
                                'items-per-page-text': 'Rows per page:'
                            }" @update:options="handleOptionsChange">
                            <template v-slot:item.email="{ item }">
                                <v-tooltip top color="#000">
                                    <template v-slot:activator="{ on }">
                                        <v-btn plain title x-small v-on="on" @click="copyText(item)"
                                            style="text-transform: none">
                                            {{ obfuscateAnyEmail(item?.email) }}
                                            <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                                                {{ copiedStates[item.id] ? "mdi-check" : "mdi-content-copy" }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item?.email }}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.totalVolume="{ item }">
                                {{ (Number(item?.totalVolume) / 10000).toFixed(2) }}
                            </template>
                            <template v-slot:item.totalDeposit="{ item }">
                                {{ Number(item?.totalDeposit)}} $ <v-icon x-small class="ml-1">mdi-swap-horizontal</v-icon> {{ Number(item?.totalDeposit * 100).toFixed(2) }} ¢
                            </template>
                            <template v-slot:item.totalWithdrawal="{ item }">
                                {{ Number(item?.totalWithdrawal)}} $ <v-icon x-small class="ml-1">mdi-swap-horizontal</v-icon> {{ Number(item?.totalWithdrawal * 100).toFixed(2) }} ¢
                            </template>
                            <template v-slot:item.name="{ item }">
                                {{ item?.fname || 'N/A' }} {{ item?.lname || '' }} ({{ item?.id || '' }})
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ALLACCOUNTSSUMMARY__ACTIONS } from "@/store/action-types";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";

export default {
    data() {
        return {
            headers: [
                { text: "Client Name", value: "name" },
                { text: "Email", value: "email" },
                { text: "Total Mt5 Acc", value: "totalTradingAccounts" },
                { text: "Total Deposit($)", value: "totalDeposit" },
                { text: "Total Withdraw($)", value: "totalWithdrawal" },
                { text: "Total Commission($)", value: "totalCommission" },
                { text: "Total Lots", value: "totalLot" },
            ],
            options: { page: 1, itemsPerPage: 10 },
            isLoading: false,
            dialog: false,
            search: "",
            selectedLevel: null,
            copiedStates: {},
        };
    },
    computed: {
        ...mapState("accountsummary", ["clientsummary", "pagination", "businessLevel", "totalCommissionSum"]),

        generateLevelsArray() {
            const levelsArray = [];
            if (this.businessLevel && this.businessLevel > 0) {
                for (let i = 0; i < this.businessLevel; i++) {
                    levelsArray.push(`Level ${i + 1}`);
                }
            }
            return ["All Level", ...levelsArray];
        },
    },

    methods: {
        ...mapActions("accountsummary", [
            ALLACCOUNTSSUMMARY__ACTIONS.CLINTSSUMMARY,
        ]),

        async levelFilter() {
            const parameter = {
                page: this.options.page || 1,
                limit: this.options.itemsPerPage || 5,
                search: this.search,
                level: this.selectedLevel,
            };
            this[ALLACCOUNTSSUMMARY__ACTIONS.CLINTSSUMMARY](parameter);
        },

        async handleSearch() {
            await this.levelFilter();
        },

        debounceSearch() {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => this.handleSearch(), 500);
        },

        handleOptionsChange() {
            this.levelFilter();
        },

        obfuscateAnyEmail(email) {
            return obfuscateEmail(email);
        },

        copyText(item) {
            navigator.clipboard.writeText(item?.email);
            this.$set(this.copiedStates, item.id, true);
            setTimeout(() => {
                this.$set(this.copiedStates, item.id, false);
            }, 1000);
        },
    },

    mounted() {
        this[ALLACCOUNTSSUMMARY__ACTIONS.CLINTSSUMMARY]();
    },
};
</script>